// extracted by mini-css-extract-plugin
export default {"status":"ProgramTable_status__B66Mx"};